import React from 'react'

import './spinner.scss';

const Spinner = () =>
    <div className="spinner loading">
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
    </div>

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/spinner/spinner.jsx